import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { checkIsAdmin } from '../lib/adminApi';
import '../styles/admin.css';

function AdminLogin() {
  const { user, signIn, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const from = location.state?.from?.pathname || '/admin';

  if (!loading && user) {
    return <Navigate to={from} replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);

    const { error: signInError } = await signIn(email.trim(), password);

    if (signInError) {
      setError(signInError.message || 'Could not sign in.');
      setSubmitting(false);
      return;
    }

    const ok = await checkIsAdmin();
    if (!ok) {
      setError('Signed in, but this account is not an administrator.');
      setSubmitting(false);
      return;
    }

    navigate(from, { replace: true });
  };

  return (
    <div className="admin-login">
      <form className="admin-login-card" onSubmit={handleSubmit}>
        <h1>Admin sign in</h1>
        <p>Sign in with an administrator account to manage the store.</p>

        {error && <p className="admin-error">{error}</p>}

        <div className="admin-field">
          <label className="admin-label" htmlFor="admin-email">Email</label>
          <input
            id="admin-email"
            className="admin-input"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </div>

        <div className="admin-field">
          <label className="admin-label" htmlFor="admin-password">Password</label>
          <input
            id="admin-password"
            className="admin-input"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>

        <button
          type="submit"
          className="admin-btn admin-btn-primary"
          disabled={submitting}
          style={{ width: '100%' }}
        >
          {submitting ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;
